export const SINGUP = "/singup";
export const LOGIN = "/login";
export const HOME = "/";
export const EVENT = "/event";
export const FORGOT_PASSWORD = "/forgot-password";
